import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyBdIw63KTFW1fzShtnlpNZN83T9oZbwqWk",
  authDomain: "seminar-development.firebaseapp.com",
  databaseURL:
    "https://seminar-development-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "seminar-development",
  storageBucket: "seminar-development.appspot.com",
  messagingSenderId: "509636313310",
  appId: "1:509636313310:web:08673ff0ff81ac1c27424f",
};
// Check Database First
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
